import { notification } from 'antd';
const defaultInfoMessageDuration = 7;
const defaultSuccessMessageDuration = 3;
const defaultWarningMessageDuration = 10;
const defaultErrorMessageDuration = 12;

class Message {
    public static sendSuccess = (
        message: string | undefined,
        duration: number = defaultSuccessMessageDuration
    ) => {
        notification['success']({
            message: message,
            duration: duration,
        });
    };

    public static sendInfo = (
        message: string | undefined,
        duration: number = defaultInfoMessageDuration
    ) => {
        notification['info']({
            message: message,
            duration: duration,
        });
    };

    public static sendWarning = (
        message: string | undefined,
        duration: number = defaultWarningMessageDuration
    ) => {
        notification['warning']({
            message: message,
            duration: duration,
        });
    };

    public static sendError = (
        message: string | undefined,
        duration: number = defaultErrorMessageDuration
    ) => {
        notification['error']({
            message: message,
            duration: duration,
        });
    };
}

export default Message;
